export default __webpack_public_path__ + "static/media/FixedIncome.eecbe994.svg";